import { render, staticRenderFns } from "./UnreadIdeaSelectModalContent.vue?vue&type=template&id=79198fc2&scoped=true&"
import script from "./UnreadIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
export * from "./UnreadIdeaSelectModalContent.vue?vue&type=script&lang=ts&"
import style0 from "./UnreadIdeaSelectModalContent.vue?vue&type=style&index=0&id=79198fc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79198fc2",
  null
  
)

export default component.exports